import { useState } from "react";
import ReactDOM from "react-dom";
import ResolveTasks from "./ResolveTasks";
import Backdrop from "../../../common/modal/Backdrop";
import Modal from "../../../common/Modal";
import AddNotes from "./AddNotes";

export default function ResolveAndCreate({itemData, showResolveTask, setShowResolveTask, inTask, inWorkQ, workqId, caseData, isTasksListing, isOnDetails}) {

    const [isModalOpened, setisModalOpened] = useState(false)
    const [preSelectedData, setpreselectedData] = useState(null)
    const [preSelectedResolvedNotes, setPreSelectedResolvedNotes] = useState(null)
    // const [isInTaskListing, setIsInTaskListing] = useState(inTask)

    function openResolveTask() {
        // setShowResolveTask(prevState => prevState = !prevState)
        if (setShowResolveTask) {
            setShowResolveTask(prevState => prevState = !prevState)
        }
    }

    function addAnother(itemData, resolveddNotes, isTasksListing) {
        // setShowResolveTask(prevState => prevState = !prevState)
        if (setShowResolveTask) {
            setShowResolveTask(prevState => prevState = !prevState)
        }
        setisModalOpened(true)
        setpreselectedData(itemData)
        setPreSelectedResolvedNotes(resolveddNotes)
        // setIsInTaskListing(isTasksListing)
    }
    function closeModalHandler() {
        setisModalOpened(false)
        setpreselectedData(null)
        setPreSelectedResolvedNotes(null)
    }

    return <>
        <ResolveTasks showResolveTask={showResolveTask} openResolveTask={openResolveTask} itemData={itemData} createAnother={addAnother} inWorkQ={inWorkQ} workqId={workqId} caseData={caseData} isTasksListing={isTasksListing}/>

        {isModalOpened && <>
            {ReactDOM.createPortal(
                <Backdrop hide={closeModalHandler} noBlur />,
                document.getElementById("backdrop-root")
            )}  
            {ReactDOM.createPortal(
                <Modal>
                    {/* caseData ? caseData : itemData */}
                    <AddNotes closeModal={closeModalHandler} preselectedValues={preSelectedData} preSelectedResolvedNotes={preSelectedResolvedNotes} isInTaskListing={inTask} directData={!isOnDetails ? itemData : null} inWorkQ={inWorkQ} workqId={workqId}/>
                </Modal>,
                document.getElementById("overlay-root")
            )}          
        </>}
    
    </>
}